const { getElement } = window.BAO.Utils

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.handleToggleButtonClick.bind(this))

    this.onPointerMove = this.onPointerMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    this.addEventListener('pointermove', this.onPointerMove)
    this.addEventListener('mouseleave', this.onMouseLeave)

    this.addEventListener('focusin', this.handleFocusIn.bind(this))

    this.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    const menuToggleEl = event.target.closest(
      '[data-header-dropdown-el="menu-dropdown-toggle"]',
    )

    if (!menuToggleEl) {
      return
    }

    const parentItemEl = menuToggleEl.closest(
      '[data-header-dropdown-el="item"]',
    )
    if (!parentItemEl) return
    const menuDropdownEl = getElement(
      '[data-header-dropdown-el="menu-dropdown"]',
      {
        context: parentItemEl,
      },
    )

    if (!menuDropdownEl) return

    const isExpanded = menuToggleEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.setAttribute('aria-expanded', 'false')
      menuDropdownEl.setAttribute('aria-hidden', 'true')
    } else {
      menuToggleEl.setAttribute('aria-expanded', 'true')
      menuDropdownEl.setAttribute('aria-hidden', 'false')
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-hidden="false"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    const menuDropdownToggleEls = document.querySelectorAll(
      '[data-header-dropdown-el="menu-dropdown-toggle"]',
    )
    const menuDropdownEls = document.querySelectorAll(
      '[data-header-dropdown-el="menu-dropdown"]',
    )

    if (menuDropdownToggleEls) {
      menuDropdownToggleEls.forEach((menuToggleEl) => {
        menuToggleEl.setAttribute('aria-expanded', 'false')
      })
    }

    if (menuDropdownEls) {
      menuDropdownEls.forEach((menuDropdownEl) => {
        menuDropdownEl.setAttribute('aria-hidden', 'true')
      })
    }
  }

  onPointerMove (event) {
    const activeTrigger = event.target.closest(
      '[data-header-dropdown-el="trigger"]',
    )

    if (!activeTrigger) {
      this.closeDropdowns()

      return
    }

    const matchedDropdown = this.querySelector(
      `[data-header-dropdown-el="menu-dropdown"]#${activeTrigger.dataset.id}`,
    )

    if (matchedDropdown) {
      this.querySelectorAll(
        '[data-header-dropdown-el="menu-dropdown"]',
      ).forEach((menuDropdownEl) => {
        menuDropdownEl.setAttribute(
          'aria-hidden',
          menuDropdownEl !== matchedDropdown,
        )
      })

      this.querySelectorAll(
        '[data-header-dropdown-el="menu-dropdown-toggle"]',
      ).forEach((menuToggleEl) => {
        menuToggleEl.setAttribute(
          'aria-expanded',
          menuToggleEl.dataset.id === matchedDropdown.id,
        )
      })
    } else {
      this.closeDropdowns()
    }
  }

  onMouseLeave () {
    this.closeDropdowns()
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
